import styled, { css } from "styled-components"

import StatefulField from "shared/components/StatefulField"

const padding = css`
  padding: 0.25rem 0;
`

export const SkuName = styled.div`
  ${padding};
  text-decoration: underline;
  cursor: pointer;
`

export const FieldExtraCharge = styled(StatefulField.MoneyInput)`
  input {
    width: 4rem;
  }
`
